import React, { useState, useEffect } from 'react';
import StyledBox, {
  StyledParagraphWithEmbeddedObjects,
} from 'views/information-module/franchise/AboutUsView/AboutUsView.styles';
import { useTranslation } from 'next-i18next';
import {
  FranchiseCommonSections,
  StyledFranchiseTitleWithDesc,
} from 'views/information-module/common/components';
import { Box } from '@mui/material';
import Typography500 from 'views/common/components/UI/Typography500';
import PATHS from 'lib/navigation/paths';
import axios, { API } from 'lib/config/axios';
import Head from 'next/head';
import generateMetaData from 'lib/utils/generateMetaData';
import useErrorsHandler from 'views/rebranded-module/common/hooks/useErrorsHandler';
import useAppNavigator from 'views/rebranded-module/common/hooks/useAppNavigator';

const aboutUsImage = {
  src: '/imgs/franchise/about/AboutFranchise.jpg',
  alt: 'Franchise About Us',
};
const historyImage = {
  src: '/imgs/franchise/about/4eagles.jpg',
  alt: 'EagleRider History',
};

const AboutUsView = (props) => {
  const { t } = useTranslation('fe_er_about_us_page');
  const handleErrorResponse = useErrorsHandler();
  const appNavigator = useAppNavigator();
  const { serverData } = props;
  const [seoValues, setSeoValues] = useState(serverData);
  const getSeoValuesData = () => {
    axios
      .get(API.seoValues)
      .then((res) => {
        setSeoValues(res.data);
      })
      .catch((error) => {
        handleErrorResponse(error, false);
      });
  };
  const verticaltabs = [
    {
      label: t('fe_er_common_franchise_header:overview'),
      value: 1,
      href: '#AUVOverview',
    },
    {
      label: t('fe_er_about_us_page:history'),
      value: 2,
      href: '#AUVHistory',
    },
    {
      label: t('fe_er_common_franchise_header:why_eaglerider'),
      value: 3,
      href: '#AUVWhyEaglerider',
    },
  ];
  const activeTab = 2;
  useEffect(() => {
    if (!serverData) {
      getSeoValuesData();
    }
  }, []);
  return (
    <>
      <Head>{seoValues && generateMetaData(seoValues)}</Head>

      <StyledBox>
        <FranchiseCommonSections
          activeTab={activeTab}
          verticaltabs={verticaltabs}
          titleWithImage={aboutUsImage}
          titleWithImgText={t('fe_er_common_franchise_header:about_us')}>
          <Box className="AUOverview" id="AUVOverview">
            <StyledFranchiseTitleWithDesc
              className="overview"
              titleVariant="h2"
              component="h2"
              title={t('fe_er_common_franchise_header:overview')}
              description={t('fe_er_about_us_page:overview_text', {
                markets_link: appNavigator.getUrl(
                  undefined,
                  PATHS.franchise.marketOpportunities().url,
                  true,
                ),
              })}
            />
          </Box>
          <Box my={{ lg: 11, md: 8, sm: 6 }} id="AUVHistory">
            <StyledParagraphWithEmbeddedObjects
              title={t('fe_er_about_us_page:history')}
              desc={t('fe_er_about_us_page:history_text')}
              titleComponet="h2"
              isImage
              collapsedSize={350}
              object={historyImage}
            />
          </Box>
          <Box id="AUVWhyEaglerider">
            <Typography500
              variant="h3"
              component="h2"
              mb={2}
              className="AUDark">
              {t('fe_er_common_franchise_header:why_eaglerider')}
            </Typography500>
            <Box mb={3}>
              <StyledFranchiseTitleWithDesc
                titleVariant="h4"
                component="h3"
                title={t('fe_er_about_us_page:confidence_header')}
                description={t('fe_er_about_us_page:confidence_text')}
              />
            </Box>
            <Box mb={3}>
              <StyledFranchiseTitleWithDesc
                titleVariant="h4"
                component="h3"
                title={t('fe_er_about_us_page:experience_header')}
                description={t('fe_er_about_us_page:experience_text')}
              />
            </Box>
            <Box mb={3}>
              <StyledFranchiseTitleWithDesc
                titleVariant="h4"
                component="h3"
                title={t('fe_er_about_us_page:marketing_advertising_header')}
                description={t(
                  'fe_er_about_us_page:marketing_advertising_text',
                )}
              />
            </Box>
            <Box mb={5}>
              <StyledFranchiseTitleWithDesc
                titleVariant="h4"
                component="h3"
                title={t('fe_er_about_us_page:training_programs_header')}
                description={t('fe_er_about_us_page:training_programs_text', {
                  inquiry_link: PATHS.franchise.becomeFranchiseDoc(),
                })}
              />
            </Box>
          </Box>
        </FranchiseCommonSections>
      </StyledBox>
    </>
  );
};
export { AboutUsView };
